import React, { useEffect, useState } from 'react';

import axios from 'axios';
import { Button, Table, Spinner, Modal, Form, InputGroup, Pagination } from 'react-bootstrap';
import { UserTradeInfo } from '../services/myAccountService';
import { GuestUserOrderId} from '../services/myAccountService';
import { getShipment, deleteShipment,trackingShipment,getSchedulePickup, cancelSchedulePickup, pickupSchedule  } from '../services/shippingService';
import swal from 'sweetalert';
import * as Yup from 'yup';
import { Formik, Form as FormikForm, Field, ErrorMessage } from 'formik';



 const ItemList = () => {
  const [items, setItems] = useState([]);
  const [filters, setFilters] = useState({ search: "", category: "" });
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [pickupId, setPickupId] = useState(null);
  const [showPickupModal, setShowPickupModal] = useState(false);
  const [pickupData, setPickupData] = useState(null);
  const [pickupDetails, setPickupDetails] = useState({
 "pickup_details": {
    "pre_scheduled_pickup": true,
    "date": {
      "year": "",
      "month": "",
      "day": ""
    },
    "ready_at": {
      "hour": "",
      "minute": ""
    },
    "ready_until": {
      "hour": "",
      "minute": ""
    },
    "pickup_location": "",
    "contact_name": "",
    "contact_phone_number": {
      "number": "",
      "extension": ""
    }
  }
});
const PickupSchema = Yup.object().shape({
  date: Yup.date().required("Pickup date is required"),
  ready_at: Yup.string().required("Ready at time is required"),
  ready_until: Yup.string().required("Ready until time is required"),
  pickup_location: Yup.string().required("Pickup location required"),
  contact_name: Yup.string().required("Contact name required"),
  contact_number: Yup.string().required("Phone number required"),
  contact_extension: Yup.string().nullable()
});




  const pageSize = 10;

  const SHIPPING_api_token = process.env.REACT_APP_CLICKSHIP_TOKEN;
  const SHIPPING_api_path = process.env.REACT_APP_CLICKSHIP_API_URL;
  const SHIPPING_api_payment_id = process.env.REACT_APP_CLICKSHIP_PAYMENT_ID
  const BASE_re_path = process.env.REACT_APP_re_path_PATH;
  const statusColors = {
    'draft': '#ccc',
    'waiting-for-scheduling':'#f0ad4e',
    'waiting-for-transit': '#f0ad4e',
    'in-transit': '#5bc0de',
    'delivered': '#5cb85c',
   ' exception': '#d9534f',
   ' missing': '#777',
    'cancelled': '#999',
  };
  const cancelSchedulePickupById=(id)=>{
  swal({
    title: "Are you sure?",
    text: "This will cancele the scheduled pickup of the shipment.",
    icon: "warning",
    buttons: ["Don't", "Cancel pickup"],
    dangerMode: true,
  }).then(async (willDelete) => {
    if (willDelete) {
  setLoading(true);
  try {
    const response = await cancelSchedulePickup(id);
    if (response) {
      swal("!", "The shipment scheduled pickup has been cancelled.", "success");
      setTimeout(() => {
        setLoading(false);  // Stop loader before reload or fetch
        fetchItems();
        window.location.reload();
      }, 2000);
    }
  } catch (err) {
    console.error(err);
    swal("Error", "Failed to cancel scheduled pickup for the shipment.", "error");
    setLoading(false);
  }
}

  });
};
const getSchedulePickupById = async (id) => {
  setLoading(true);
  try {
    const response = await getSchedulePickup(id);
    if (response?.data) {
      setPickupData(response.data);   // Save the pickup data
      setShowPickupModal(true);       // Show the modal
    }
  } catch (err) {
    console.error(err.message);
    swal("Error", "Shipment schedule information not found", "error");
  } finally {
    setLoading(false);
  }
};


 const deleteShipmentById = (id) => {
  swal({
    title: "Are you sure?",
    text: "This will permanently delete the shipment.",
    icon: "warning",
    buttons: ["Cancel", "Delete"],
    dangerMode: true,
  }).then(async (willDelete) => {
    if (willDelete) {
  setLoading(true);
  try {
    const response = await deleteShipment(id);
    if (response) {
      swal("Deleted!", "The shipment has been removed.", "success");
      setTimeout(() => {
        setLoading(false);  // Stop loader before reload or fetch
        fetchItems();
        window.location.reload();
      }, 2000);
    }
  } catch (err) {
    console.log(err.message);
    swal("Error", "Failed to delete the shipment.", "error");
    setLoading(false);
  }
}

  });
};
  const schedulePickupShipmentById = (id) => {
    setPickupId(id);         // Save ID to state
    setShowModal(true);  }
 

  const getHeaders_1 = () => {
    const token = localStorage.getItem('token');
    return { 'Authorization': 'Token ' + token }
}
  const getHeaders = () => {
    
    return { 'Authorization': SHIPPING_api_token, 
             'Content-Type': 'application/json'
     }
    }
  

  const fetchItems = async () => {
  setLoading(true);
  try {
    const response = await axios.get(`${BASE_re_path}/combined-items/`, {
      params: { page, search: filters.search, exclude_status: 1 },
      headers: getHeaders_1(),
    });

    const items_1 = response.data.results;

    // Fetch shipment details
    const responses = await Promise.all(
      items_1.map(id => getShipment(id.shipment_id).catch(() => null))
    );
    const shipments = responses
      .filter(r => r?.data?.shipment)
      .map(r => r.data.shipment);

    setItems(shipments);
    setCount(response.data.count); // ✅ use count from backend
  } catch (err) {
    console.error(err);
    swal("Error", "Failed fetching items.", "error");
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    fetchItems();
  }, [page, filters]);

  
  const totalPages = Math.ceil(count / pageSize);

  return (
    <>
    {loading && (
  <div className="overlay-spinner">
    <div className="spinner"></div>
    <p className="spinner-text">Please wait...</p>
  </div>
)}
    <div style={{ padding: "1rem" }}>
      <h2>Items</h2>

      {/* Search and Filter */}
      <div style={{ marginBottom: "1rem" }}>
        <input
          type="text"
          placeholder="Search..."
          value={filters.search}
          onChange={(e) => setFilters({ ...filters, search: e.target.value })}
        />
        <select
          value={filters.category}
          onChange={(e) => setFilters({ ...filters, category: e.target.value })}
          style={{ marginLeft: "1rem" }}
        >
          <option value="">All Categories</option>
          <option value="phones">Phones</option>
          <option value="laptops">Laptops</option>
        </select>
      </div>

      {/* Item List */}
     

      <ul>
        {items.length>0 && items.map((item) => (
          <div className="mb-3 border rounded-lg p-2"key={item.id}>
            <div className='d-flex'><h6 className='mr-4'>Customer Name: {item.details.origin.contact_name}</h6><span className='float-right'> Order No.: {item.orderNo}</span> <span style={{fontSize:14, fontWeight:500, marginLeft:40}}>Date Of Order: {item.orderDate} </span></div>
            <div className='p-1 mt-1 mb-1 grid-container1'>
                <span style={{fontSize:14, fontWeight:800}}>Address:</span>
                <span style={{fontSize:14, fontWeight:500}}>{item.details.origin.address.address_line1}</span>
             {item.addressLine2&&<> <span style={{fontSize:14, fontWeight:500}}>{item.details.origin.address.address_line2}</span><br></br></>}
              <span style={{fontSize:14, fontWeight:500}}> {item.details.origin.address.city}</span>
               <span style={{fontSize:14, fontWeight:500}}>{item.details.origin.address.region}</span>
                <span style={{fontSize:14, fontWeight:500}}>{item.details.origin.address.postal_code}</span>
            </div>
            
               
    
    <div className='p-1 mt-1 mb-1 grid-container1 bg-floralwhite'>
                
                
    <div className='float-left grid-container1 m'>
   { item.state!="cancelled" && <div><button
      onClick={()=>deleteShipmentById(`${item.id}`)}
      style={{
        backgroundColor: '#d9534f', // Bootstrap red
        color: 'white',
        border: 'none',
        padding: '8px 12px',
        borderRadius: '4px',
        cursor: 'pointer',
        float:'inline-end',
        marginTop:'20px',
        width:"200px"
      }}
    >
      Cancel shipment
    </button></div>}
     {!item.pickup_confirmation_number&&item.state!='cancelled'&&
<div><button
      onClick={()=>schedulePickupShipmentById(`${item.id}`)}
      style={{
        backgroundColor: '#d9534f', // Bootstrap red
        color: 'white',
        border: 'none',
        padding: '8px 12px',
        borderRadius: '4px',
        cursor: 'pointer',
        float:'inline-end',
        marginTop:'20px',
        width:"200px"
      }}
    >
      Schedule pickup
    </button></div>}
         {item.pickup_confirmation_number&&item.state==="waiting-for-transit"&&
<div><button
      onClick={()=>cancelSchedulePickupById(`${item.id}`)}
      style={{
        backgroundColor: '#d9534f', // Bootstrap red
        color: 'white',
        border: 'none',
        padding: '8px 12px',
        borderRadius: '4px',
        cursor: 'pointer',
        float:'inline-end',
        marginTop:'20px',
        width:"200px"
      }}
    >
      Cancel schedule pickup
    </button></div>}
    <div><button
      onClick={()=> getSchedulePickupById(`${item.id}`)}
      style={{
        backgroundColor: '#d9534f', // Bootstrap red
        color: 'white',
        border: 'none',
        padding: '8px 12px',
        borderRadius: '4px',
        cursor: 'pointer',
        float:'inline-end',
        marginTop:'20px',
        width:"200px"
      }}
    >
      View Pickup Details
    </button></div>
    
    <span style={{fontSize:14, fontWeight:800}}>Shipment details:</span>
                  <span>Carrier: {item.rate.carrier_name}</span>
                    <span>Tracking no.: {item.primary_tracking_number} </span>
              <div ><span>Pickup schedule status: </span> <button 
      style={{
        backgroundColor: statusColors[`${item.state}`] || '#eee',
        color: '#fff',
        padding: '8px 12px',
        border: 'none',
        borderRadius: '4px',
        color:"black",
        fontWeight:800
      }}
    >
      {item.state}
    </button>
    
    </div> 
                <span>Shipping cost: ${(item.rate.total.value / 100).toFixed(2)} </span>
                 <span>Tracking url: <a href={item.tracking_url}>{item.tracking_url}</a></span>
                <span>Shipment id: {item.id} </span>
                <span>Pickup confiramtion number: {item.pickup_confirmation_number}</span>
    </div>
                 
              
               
                     </div>
                
          </div>
        ))}
      </ul>

      {/* Pagination */}
      <div style={{ marginTop: "1rem" }}>
        {Array.from({ length: totalPages }, (_, i) => (
          <button
            key={i + 1}
            onClick={() => setPage(i + 1)}
            disabled={page === i + 1}
            style={{
              marginRight: "0.5rem",
              backgroundColor: page === i + 1 ? "#ddd" : "#fff",
            }}
          >
            {i + 1}
          </button>
        ))}
      </div>
    </div>
    <Modal show={showPickupModal} onHide={() => setShowPickupModal(false)}>
  <Modal.Header closeButton>
    <Modal.Title>Scheduled Pickup Details</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {pickupData ? (
      <div>
        <p><strong>Pickup Date:</strong> {pickupData.date}</p>
        <p><strong>Pickup Location:</strong> {pickupData.pickup_location}</p>
        <p><strong>Contact Name:</strong> {pickupData.contact_name}</p>
        <p><strong>Contact Phone:</strong> {pickupData.contact_phone_number?.number}</p>
        <p><strong>Ready At:</strong> {pickupData.ready_at?.hour}:{pickupData.ready_at?.minute}</p>
        <p><strong>Ready Until:</strong> {pickupData.ready_until?.hour}:{pickupData.ready_until?.minute}</p>
        {/* Add more fields if available */}
      </div>
    ) : (
      <p>No data found.</p>
    )}
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowPickupModal(false)}>Close</Button>
  </Modal.Footer>
</Modal>

   <Modal show={showModal} onHide={() => setShowModal(false)}>
  <Formik
     initialValues={ {
  date: '',
  ready_at: '',
  ready_until: '',
  pickup_location: '',
  contact_name: '',
  contact_number: '',
  contact_extension: ''
}
}
    validationSchema={PickupSchema}
    onSubmit={async (values, { setSubmitting }) => {
      setLoading(true);
      try {
    const d = new Date(values.date);
    const [readyHour, readyMinute] = values.ready_at.split(':').map(Number);
    const [untilHour, untilMinute] = values.ready_until.split(':').map(Number);

    const pickup_details = {
  pickup_details: {
    pre_scheduled_pickup: true,
    date: {
      year: d.getFullYear(),
      month: d.getMonth() + 1,
      day: d.getDate()
    },
    ready_at: {
      hour: readyHour,
      minute: readyMinute
    },
    ready_until: {
      hour: untilHour,
      minute: untilMinute
    },
    pickup_location: values.pickup_location,
    contact_name: values.contact_name,
    contact_phone_number: {
      number: values.contact_number,
      extension: values.contact_extension || ""
    }
  }
};

        
        const res = await pickupSchedule(pickupId,  pickup_details);
        if (res) {
          swal("Success", "Pickup scheduled successfully", "success");
          fetchItems();
          setShowModal(false);
        }
      } catch (err) {
        console.error(err);
        swal("Error", "Failed to schedule pickup", "error");
      } finally {
        setLoading(false);
        setSubmitting(false);
      }
    }}
  >
    {({ isSubmitting }) => (
      <FormikForm>
        <Modal.Header closeButton>
          <Modal.Title>Schedule Pickup</Modal.Title>
        </Modal.Header>
        <Modal.Body>
         <div>
        <label>Pickup Date</label>
        <Field type="date" name="date" className="form-control" />
        <ErrorMessage name="date" component="div" className="text-danger" />
      </div>

      <div className="d-flex gap-2">
        <div>
          <label>Ready At</label>
          <Field name="ready_at" type="time" className="form-control" />
          <ErrorMessage name="ready_at" component="div" className="text-danger" />

        </div>
      </div>

      <div className="d-flex gap-2">
        <div>
          <label>Ready Until</label>
          <Field name="ready_until" type="time" className="form-control" />
          <ErrorMessage name="ready_until" component="div" className="text-danger" />

        </div>
      </div>

      <div>
        <label>Pickup Location</label>
        <Field type="text" name="pickup_location" className="form-control" />
        <ErrorMessage name="pickup_location" component="div" className="text-danger" />
      </div>

      <div>
        <label>Contact Name</label>
        <Field type="text" name="contact_name" className="form-control" />
        <ErrorMessage name="contact_name" component="div" className="text-danger" />
      </div>

      <div className="d-flex gap-2">
        <div>
          <label>Phone Number</label>
          <Field type="text" name="contact_number" className="form-control" />
          <ErrorMessage name="contact_number" component="div" className="text-danger" />
        </div>
        <div>
          <label>Extension</label>
          <Field type="text" name="contact_extension" className="form-control" />
          <ErrorMessage name="contact_extension" component="div" className="text-danger" />
        </div>
      </div>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
          <Button type="submit" variant="primary" disabled={isSubmitting}>
            {isSubmitting ? "Scheduling..." : "Schedule Pickup"}
          </Button>
        </Modal.Footer>
      </FormikForm>
    )}
  </Formik>
</Modal>

    </>
  );
};

export default ItemList;
 